var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnergyArcBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "-0.7222520492602436 -1.0417320164033694 416.53117797500386 111.17069099620443",
    width: 412.53,
    height: 107.17,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.96 9.52C35.22 12.69 69.34 38.03 73.6 41.19C79.16 45.32 69.52 49.91 63.94 45.75C55.4 39.41 25.55 17.25 21.28 14.08C15.69 9.92 25.36 5.33 30.96 9.52Z",
    id: "awq031Odd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.96 9.52C35.22 12.69 69.34 38.03 73.6 41.19C79.16 45.32 69.52 49.91 63.94 45.75C55.4 39.41 25.55 17.25 21.28 14.08C15.69 9.92 25.36 5.33 30.96 9.52Z",
    id: "fOi2822Jv"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.61 70.4C156.94 70.13 207.54 67.96 213.86 67.68C222.11 67.33 221.77 75.26 213.47 75.62C200.82 76.16 156.54 78.07 150.22 78.34C141.91 78.69 142.27 70.74 150.61 70.4Z",
    id: "aZQlEPVN"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.61 70.4C156.94 70.13 207.54 67.96 213.86 67.68C222.11 67.33 221.77 75.26 213.47 75.62C200.82 76.16 156.54 78.07 150.22 78.34C141.91 78.69 142.27 70.74 150.61 70.4Z",
    id: "e2gA3ZQ0wU"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.82 72.01C315.75 69.42 355.3 48.6 360.25 46C366.69 42.6 373.13 49.35 366.64 52.75C356.75 57.96 322.16 76.17 317.21 78.78C310.71 82.19 304.27 75.43 310.82 72.01Z",
    id: "d71idC8hz9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.82 72.01C315.75 69.42 355.3 48.6 360.25 46C366.69 42.6 373.13 49.35 366.64 52.75C356.75 57.96 322.16 76.17 317.21 78.78C310.71 82.19 304.27 75.43 310.82 72.01Z",
    id: "b1RFIAZDqb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.53 88.24C130.86 88.57 181.52 91.18 187.85 91.5C196.1 91.93 194.07 99.73 185.77 99.3C173.1 98.65 128.79 96.37 122.45 96.04C114.13 95.61 116.17 87.79 124.53 88.24Z",
    id: "c5yMVVHsD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.53 88.24C130.86 88.57 181.52 91.18 187.85 91.5C196.1 91.93 194.07 99.73 185.77 99.3C173.1 98.65 128.79 96.37 122.45 96.04C114.13 95.61 116.17 87.79 124.53 88.24Z",
    id: "bg5knI1FJ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.59 96.68C310.04 94.58 353.69 77.73 359.15 75.63C366.26 72.88 371.21 80.14 364.05 82.91C353.15 87.12 314.95 101.86 309.5 103.96C302.33 106.73 297.37 99.44 304.59 96.68Z",
    id: "byT0Y9fyT"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.59 96.68C310.04 94.58 353.69 77.73 359.15 75.63C366.26 72.88 371.21 80.14 364.05 82.91C353.15 87.12 314.95 101.86 309.5 103.96C302.33 106.73 297.37 99.44 304.59 96.68Z",
    id: "azv3uJmwG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.03 50.2C52.46 51.94 79.97 65.89 83.4 67.63C90.08 71.06 80.8 76.92 74.01 73.46C67.14 69.98 43.14 57.78 39.72 56.04C32.95 52.6 42.24 46.74 49.03 50.2Z",
    id: "a48I0m8BLj"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.03 50.2C52.46 51.94 79.97 65.89 83.4 67.63C90.08 71.06 80.8 76.92 74.01 73.46C67.14 69.98 43.14 57.78 39.72 56.04C32.95 52.6 42.24 46.74 49.03 50.2Z",
    id: "dE4Xjiuud"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.94 89.26C226.89 88.12 258.52 78.94 262.47 77.79C270.21 75.58 273.59 83.78 265.78 86.04C257.88 88.33 230.25 96.34 226.29 97.49C218.5 99.73 215.11 91.52 222.94 89.26Z",
    id: "clmmnpULn"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.94 89.26C226.89 88.12 258.52 78.94 262.47 77.79C270.21 75.58 273.59 83.78 265.78 86.04C257.88 88.33 230.25 96.34 226.29 97.49C218.5 99.73 215.11 91.52 222.94 89.26Z",
    id: "d1RIpSyXyq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.89 24C378.54 21.75 399.81 3.71 402.47 1.45C407.69 -2.93 416.44 3.31 411.19 7.77C405.87 12.26 387.27 28.02 384.62 30.27C379.38 34.7 370.62 28.46 375.89 24Z",
    id: "d2Y2pPYIKp"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.89 24C378.54 21.75 399.81 3.71 402.47 1.45C407.69 -2.93 416.44 3.31 411.19 7.77C405.87 12.26 387.27 28.02 384.62 30.27C379.38 34.7 370.62 28.46 375.89 24Z",
    id: "ajd5aHMaL"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.06 78.29C44.62 76.2 40.49 73.93 36.69 71.52C35.35 70.59 34.18 69.41 35.3 68.91C36.42 68.4 39.16 68.79 41.5 69.54C44.41 70.44 46.6 71.74 49.15 72.72C58.07 76.13 66.06 80.05 75.26 83.29C78.93 84.47 81.99 86.14 84.08 88.14C86.03 89.04 86.51 89.89 85.75 90.68C86.84 91.94 85.61 92.55 83.71 92.77C81.61 92.95 79.81 92.08 78.19 91.15C77.38 90.73 76.51 90.35 75.59 90.01C66.47 86.23 57.4 82.42 49.06 78.29Z",
    id: "e2tmHun127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.06 78.29C44.62 76.2 40.49 73.93 36.69 71.52C35.35 70.59 34.18 69.41 35.3 68.91C36.42 68.4 39.16 68.79 41.5 69.54C44.41 70.44 46.6 71.74 49.15 72.72C58.07 76.13 66.06 80.05 75.26 83.29C78.93 84.47 81.99 86.14 84.08 88.14C86.03 89.04 86.51 89.89 85.75 90.68C86.84 91.94 85.61 92.55 83.71 92.77C81.61 92.95 79.81 92.08 78.19 91.15C77.38 90.73 76.51 90.35 75.59 90.01C66.47 86.23 57.4 82.42 49.06 78.29Z",
    id: "bouHeyfNq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.57 103.32C254.68 104.8 249.7 106 244.7 106.93C242.84 107.23 240.72 107.29 240.62 106.39C240.52 105.48 242.38 104.11 244.51 103.15C247.09 101.94 249.87 101.36 252.38 100.39C261.21 97.03 270.22 94.45 278.96 90.84C282.29 89.34 285.96 88.45 289.58 88.27C291.72 87.63 293.05 87.78 293.72 88.63C295.88 88.65 296.06 89.67 295.41 90.88C294.61 92.18 292.6 92.77 290.59 93.22C289.65 93.47 288.73 93.77 287.83 94.13C278.44 97.42 269.03 100.66 259.57 103.32Z",
    id: "j5hLYslRT"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.57 103.32C254.68 104.8 249.7 106 244.7 106.93C242.84 107.23 240.72 107.29 240.62 106.39C240.52 105.48 242.38 104.11 244.51 103.15C247.09 101.94 249.87 101.36 252.38 100.39C261.21 97.03 270.22 94.45 278.96 90.84C282.29 89.34 285.96 88.45 289.58 88.27C291.72 87.63 293.05 87.78 293.72 88.63C295.88 88.65 296.06 89.67 295.41 90.88C294.61 92.18 292.6 92.77 290.59 93.22C289.65 93.47 288.73 93.77 287.83 94.13C278.44 97.42 269.03 100.66 259.57 103.32Z",
    id: "aXmqs2NLP"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.37 43.21C25.23 43.63 24.81 43.99 24.18 44.23C24.17 44.45 24.07 44.67 23.89 44.86C23.71 45.05 23.46 45.22 23.13 45.36C22.82 45.49 22.44 45.59 22.05 45.63C21.65 45.69 21.23 45.69 20.82 45.65C18.86 45.6 18.13 44.71 17.6 43.77C17.31 43.35 16.94 42.93 16.48 42.54C12.13 38.51 8.21 34.37 4.75 30.13C2.89 27.92 1.46 25.62 0.45 23.28C0.12 22.4 0.17 21.32 1.47 21.04C2.77 20.76 4.66 21.38 5.95 22.23C7.57 23.28 8.24 24.57 9.44 25.62C13.88 29.36 17.08 33.4 21.85 37.09C23.9 38.51 25 40.26 24.95 42C25.36 42.37 25.51 42.81 25.37 43.21Z",
    id: "feERmAtpP"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.37 43.21C25.23 43.63 24.81 43.99 24.18 44.23C24.17 44.45 24.07 44.67 23.89 44.86C23.71 45.05 23.46 45.22 23.13 45.36C22.82 45.49 22.44 45.59 22.05 45.63C21.65 45.69 21.23 45.69 20.82 45.65C18.86 45.6 18.13 44.71 17.6 43.77C17.31 43.35 16.94 42.93 16.48 42.54C12.13 38.51 8.21 34.37 4.75 30.13C2.89 27.92 1.46 25.62 0.45 23.28C0.12 22.4 0.17 21.32 1.47 21.04C2.77 20.76 4.66 21.38 5.95 22.23C7.57 23.28 8.24 24.57 9.44 25.62C13.88 29.36 17.08 33.4 21.85 37.09C23.9 38.51 25 40.26 24.95 42C25.36 42.37 25.51 42.81 25.37 43.21Z",
    id: "c38FOBN75A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.15 60.1C95.68 59.71 94.41 59.21 94.57 58.1C94.55 57.87 94.61 57.64 94.74 57.42C94.87 57.2 95.07 57 95.32 56.83C95.58 56.67 95.87 56.54 96.2 56.47C96.53 56.38 96.89 56.35 97.24 56.36C97.7 56.04 98.32 55.85 98.98 55.81C99.65 55.78 100.32 55.9 100.86 56.18C103.63 56.33 106.24 57.13 108.25 58.42C113.38 61.45 119.37 63.66 124.77 66.51C126.32 67.28 128.26 67.84 129.7 68.8C130.88 69.62 131.69 70.66 131.03 71.44C130.37 72.21 128.71 72.06 127.36 71.77C123.8 70.98 120.38 69.94 117.13 68.69C110.85 66.32 104.77 63.7 98.96 60.85C98.39 60.55 97.79 60.31 97.15 60.1Z",
    id: "b9vkjwqdV"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.15 60.1C95.68 59.71 94.41 59.21 94.57 58.1C94.55 57.87 94.61 57.64 94.74 57.42C94.87 57.2 95.07 57 95.32 56.83C95.58 56.67 95.87 56.54 96.2 56.47C96.53 56.38 96.89 56.35 97.24 56.36C97.7 56.04 98.32 55.85 98.98 55.81C99.65 55.78 100.32 55.9 100.86 56.18C103.63 56.33 106.24 57.13 108.25 58.42C113.38 61.45 119.37 63.66 124.77 66.51C126.32 67.28 128.26 67.84 129.7 68.8C130.88 69.62 131.69 70.66 131.03 71.44C130.37 72.21 128.71 72.06 127.36 71.77C123.8 70.98 120.38 69.94 117.13 68.69C110.85 66.32 104.77 63.7 98.96 60.85C98.39 60.55 97.79 60.31 97.15 60.1Z",
    id: "d47M6EwuQp"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.44 69.1C262.2 69.74 260.92 70.21 259.58 69.55C259.26 69.44 258.99 69.28 258.77 69.09C258.55 68.91 258.39 68.69 258.31 68.46C258.21 68.23 258.2 68 258.26 67.76C258.32 67.53 258.44 67.31 258.63 67.11C258.44 66.69 258.5 66.23 258.77 65.83C259.06 65.43 259.56 65.11 260.17 64.94C261.74 63.43 264.06 62.33 266.72 61.85C273.19 60.47 279 58.16 285.34 56.53C287.11 56.04 288.79 55.2 290.76 54.88C292.38 54.62 294.15 54.69 294.83 55.47C295.5 56.26 294.48 57.13 293.45 57.76C290.67 59.4 287.65 60.83 284.42 62.05C278.25 64.43 271.86 66.57 265.29 68.45C264.64 68.62 264.01 68.83 263.44 69.1Z",
    id: "aywFwiEAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.44 69.1C262.2 69.74 260.92 70.21 259.58 69.55C259.26 69.44 258.99 69.28 258.77 69.09C258.55 68.91 258.39 68.69 258.31 68.46C258.21 68.23 258.2 68 258.26 67.76C258.32 67.53 258.44 67.31 258.63 67.11C258.44 66.69 258.5 66.23 258.77 65.83C259.06 65.43 259.56 65.11 260.17 64.94C261.74 63.43 264.06 62.33 266.72 61.85C273.19 60.47 279 58.16 285.34 56.53C287.11 56.04 288.79 55.2 290.76 54.88C292.38 54.62 294.15 54.69 294.83 55.47C295.5 56.26 294.48 57.13 293.45 57.76C290.67 59.4 287.65 60.83 284.42 62.05C278.25 64.43 271.86 66.57 265.29 68.45C264.64 68.62 264.01 68.83 263.44 69.1Z",
    id: "a2yQgoSROk"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.75 36.35C402.51 35.44 403.42 34.68 405.03 34.95C405.38 34.97 405.72 35.04 406.04 35.17C406.34 35.28 406.61 35.44 406.83 35.62C407.04 35.82 407.2 36.04 407.27 36.27C407.36 36.5 407.37 36.73 407.3 36.96C407.73 37.32 407.94 37.75 407.92 38.2C407.9 38.65 407.62 39.06 407.15 39.38C406.59 41.18 405.1 42.79 402.94 43.93C397.81 46.87 393.82 50.51 388.94 53.64C387.6 54.55 386.54 55.76 384.93 56.56C383.58 57.22 381.92 57.61 380.85 57.06C379.77 56.51 380.21 55.43 380.78 54.58C382.39 52.35 384.33 50.25 386.58 48.29C390.87 44.49 395.48 40.86 400.42 37.43C400.93 37.11 401.38 36.74 401.75 36.35Z",
    id: "a2feufgy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.75 36.35C402.51 35.44 403.42 34.68 405.03 34.95C405.38 34.97 405.72 35.04 406.04 35.17C406.34 35.28 406.61 35.44 406.83 35.62C407.04 35.82 407.2 36.04 407.27 36.27C407.36 36.5 407.37 36.73 407.3 36.96C407.73 37.32 407.94 37.75 407.92 38.2C407.9 38.65 407.62 39.06 407.15 39.38C406.59 41.18 405.1 42.79 402.94 43.93C397.81 46.87 393.82 50.51 388.94 53.64C387.6 54.55 386.54 55.76 384.93 56.56C383.58 57.22 381.92 57.61 380.85 57.06C379.77 56.51 380.21 55.43 380.78 54.58C382.39 52.35 384.33 50.25 386.58 48.29C390.87 44.49 395.48 40.86 400.42 37.43C400.93 37.11 401.38 36.74 401.75 36.35Z",
    id: "g3oVJKlD8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#awq031Odd",
    opacity: 1,
    fill: "#faa629",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#awq031Odd",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fOi2822Jv",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fOi2822Jv",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aZQlEPVN",
    opacity: 1,
    fill: "#00afef",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aZQlEPVN",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e2gA3ZQ0wU",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e2gA3ZQ0wU",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d71idC8hz9",
    opacity: 1,
    fill: "#21b9e4",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d71idC8hz9",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1RFIAZDqb",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1RFIAZDqb",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c5yMVVHsD",
    opacity: 1,
    fill: "#59fac3",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c5yMVVHsD",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bg5knI1FJ",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bg5knI1FJ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#byT0Y9fyT",
    opacity: 1,
    fill: "#59fac3",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#byT0Y9fyT",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#azv3uJmwG",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#azv3uJmwG",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a48I0m8BLj",
    opacity: 1,
    fill: "#ffff3b",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a48I0m8BLj",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dE4Xjiuud",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dE4Xjiuud",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#clmmnpULn",
    opacity: 1,
    fill: "#35ce8d",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#clmmnpULn",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1RIpSyXyq",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1RIpSyXyq",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d2Y2pPYIKp",
    opacity: 1,
    fill: "#faa629",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d2Y2pPYIKp",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ajd5aHMaL",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ajd5aHMaL",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e2tmHun127",
    opacity: 1,
    fill: "#08576d",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e2tmHun127",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bouHeyfNq",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bouHeyfNq",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j5hLYslRT",
    opacity: 1,
    fill: "#08576d",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j5hLYslRT",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aXmqs2NLP",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aXmqs2NLP",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#feERmAtpP",
    opacity: 1,
    fill: "#08576d",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#feERmAtpP",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c38FOBN75A",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c38FOBN75A",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b9vkjwqdV",
    opacity: 1,
    fill: "#08576d",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b9vkjwqdV",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d47M6EwuQp",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d47M6EwuQp",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aywFwiEAC",
    opacity: 1,
    fill: "#08576d",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aywFwiEAC",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2yQgoSROk",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2yQgoSROk",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2feufgy",
    opacity: 1,
    fill: "#08576d",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2feufgy",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g3oVJKlD8",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g3oVJKlD8",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyArcBottom);
export default __webpack_public_path__ + "static/media/energy-arc-bottom.4af3cff3b933274c8a1caebbad4024ad.svg";
export { ForwardRef as ReactComponent };